export default "__VITE_ASSET__cf776ac6__"